<template>
  <div v-if="place !== undefined" class="request-btn-container d-flex justify-content-between">
    <router-link :to="{ name: pageName.NEW_OFFER_PAGE_WITH_PLACE_ID, params: { placeId: place.id } }">
      <div class="button-block">
        <button v-t="'place_card.request_for.btn.label'" class="col-6 btn request-for-btn" />
      </div>
    </router-link>
    <PlaceFavoriteIconBlock :place="place" />
  </div>
</template>

<script>
import PlaceFavoriteIconBlock from '@/components/place-favorite-icon-block/PlaceFavoriteIconBlock.vue'
import pageName from '@/constants/pageName.js'
export default {
  name: 'RequestBtnAndFavoriteIconRow',
  components: {
    PlaceFavoriteIconBlock,
  },
  props: {
    place: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      pageName,
    }
  },
}
</script>

<style scoped lang="scss">
.request-btn-container {
  max-width: 80rem;
}

a {
  text-decoration: none;
}

.request-for-btn {
  font-family: Montserrat, serif;
  display: flex;
  height: 2.5rem;
  padding: 0.625rem 0.938rem;
  justify-content: center;
  align-items: center;
  gap: 0.625rem;
  border-radius: 0.25rem;
  border: 0.063rem solid #000;
  background: #fff;
  text-transform: uppercase;
  color: #000;
  text-align: center;
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  width: 100%;
}

.request-for-btn:hover, .request-for-btn:focus {
  color: #fff;
  background: var(--main-theme-color);
}
</style>
